import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Stack, xcss } from '@atlaskit/primitives';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';

import { useElementVisibility, ELEMENTS } from '../hooks/useIsElementVisible';

import { IncomingLinksRow } from './IncomingLinksRow';
import { OutgoingLinksRow } from './OutgoingLinksRow';
// eslint-disable-next-line import/no-cycle
import { JiraWorkItemsRow } from './JiraWorkItemsRow';
import { CustomContentRow } from './CustomContentRow';
import { AttachmentsRow } from './AttachmentsRow';

const i18n = defineMessages({
	connectionsSectionTitle: {
		id: 'details-panel.connections-section.title',
		defaultMessage: 'Connections',
		description:
			'Title for section containing metadata related to connections (links, files, custom content)',
	},
});

const connectionsSectionStyles = xcss({
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
	marginTop: 'space.300',
});

export const ConnectionsSection = () => {
	const { isElementVisible } = useElementVisibility();

	return (
		<Stack testId="connections-section" xcss={connectionsSectionStyles}>
			<FormattedMessage {...i18n.connectionsSectionTitle} tagName="h4" />
			<ErrorBoundary attribution={Attribution.DISCO}>
				<Stack>
					<IncomingLinksRow />
					<OutgoingLinksRow />
					<AttachmentsRow />
					{isElementVisible(ELEMENTS.ROWS.CUSTOM_CONTENT) && <CustomContentRow />}
					<JiraWorkItemsRow />
				</Stack>
			</ErrorBoundary>
		</Stack>
	);
};
